import Vue from 'vue';
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

import th from '../languages/th'
import en from '../languages/en'

const i18n = new VueI18n({
	locale: 'th', // set locale
	messages : { en:en , th:th},
});

export default i18n;